import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectRoutingModule } from 'app/modules/project/project-routing.module';

import { ProjectFormComponent } from 'app/modules/project/components/project-form/project-form.component';
import { ProjectDetailComponent } from 'app/modules/project/components/project-detail/project-detail.component';
import { DetailDetailComponent } from 'app/modules/project/components/detail-detail/detail-detail.component';
import { FileEditorComponent } from 'app/modules/project/components/file-editor/file-editor.component';
import { MyDatepickerComponent } from 'app/modules/project/components/my-datepicker/my-datepicker.component';
import { DetailFormInlineComponent } from 'app/modules/project/components/detail-form-inline/detail-form-inline.component';

import { ProjectService } from 'app/modules/project/services/project.service';
import { DetailService } from 'app/modules/project/services/detail.service';

import { DetailResolver } from 'app/modules/project/resolvers/detail-resolver';
import { ProjectResolver } from 'app/modules/project/resolvers/project-resolver';

import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DatepickerModule } from 'ng2-datepicker';
import { NgUploaderModule } from 'ngx-uploader';

import { SelectFieldsPipe } from 'app/modules/project/pipes/select-fields.pipe';
import { TeaserItemPipe } from 'app/modules/project/pipes/teaser-item.pipe';
import { TeaserBlockComponent } from 'app/modules/project/components/teaser-block/teaser-block.component';
import { DetailFormContainerComponent } from './components/detail-form-container/detail-form-container.component';
import { Autosize } from 'ng-autosize';
import { TagInputModule } from 'ngx-chips';
import { QuillModule } from 'ngx-quill';
import { CoreModule } from 'app/modules/core/core.module';
import { NgPipesModule } from 'ngx-pipes';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { NgSelectModule } from '@ng-select/ng-select';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { SDGCertificateComponent } from './components/sdg-certificate/sdg-certificate.component';
import { ResilienceChallengeListComponent } from './components/resilience-challenge-list/resilience-challenge-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ProjectRoutingModule,
    FormsModule,
    HttpClientModule,
    NgSelectModule,
    TagInputModule,
    DatepickerModule,
    NgUploaderModule,
    QuillModule,
    NgPipesModule,
    NgxDnDModule,
  ],
  declarations: [
    ProjectFormComponent,
    ProjectDetailComponent,
    DetailDetailComponent,
    FileEditorComponent,
    MyDatepickerComponent,
    DetailFormInlineComponent,
    TeaserBlockComponent,
    SelectFieldsPipe,
    TeaserItemPipe,
    DetailFormContainerComponent,
    Autosize,
    ExpansionPanelComponent,
    SDGCertificateComponent,
    ResilienceChallengeListComponent,
  ],
  exports: [ProjectDetailComponent, TeaserItemPipe, SDGCertificateComponent],
  providers: [ProjectResolver, DetailResolver, ProjectService, DetailService],
})
export class ProjectModule {}
